'use client'

import React from 'react'
import { ACKODRIVE_LOGO_HORIZONTAL_LIGHT } from '@constants/ackodriveLogo'
import * as Styles from './styles'
// import { checkReleaseFeatureToggle, RFT_KEYS } from 'utils/featureToggles'

export interface CompanyAddressPropsT {
  margin?: string
  className?: string
  isLogoUnClickable?: boolean
}

const CompanyAddress = (props: CompanyAddressPropsT) => {
  const { margin, className, isLogoUnClickable } = props

  const handleClick = () => {
    if (!isLogoUnClickable) {
      window.location.href = '/'
    }
  }

  return (
    <Styles.CAWrapper className={className} margin={margin}>
      <div
        onClick={() => {
          handleClick()
        }}>
        <Styles.CAADNewLogo
          src={ACKODRIVE_LOGO_HORIZONTAL_LIGHT}
          width={100}
          height={46}
          alt="Ackodrive footer New Address Logo"
          loading="lazy"
        />
      </div>
      <Styles.Address>
        36/5, Hustlehub One East, Somasandrapalya, 27th Main Rd, Sector 2, HSR Layout, Bengaluru, Karnataka 560102.
      </Styles.Address>
    </Styles.CAWrapper>
  )
}

export default CompanyAddress
